// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"a7f87e72","239":"bb2d3923","455":"6811f4e1","488":"0f2b7108","977":"e0087c09"}[chunkId] + ".chunk.js";
};